document.addEventListener("DOMContentLoaded", () => {
  function initSliderForCollection(collection) {
    if (!collection || collection.dataset.sliderInited === "true") return;
    const slider = collection.querySelector(".custom-collection-slider");
    const track = collection.querySelector(".custom-collection-track");
    const cards = Array.from(
      collection.querySelectorAll(".custom-collection-card")
    );
    const leftArrow = collection.querySelector(".custom-navigation-left");
    const rightArrow = collection.querySelector(".custom-navigation-right");

    if (!slider || !track || cards.length === 0) return;

    /* -------------------------
        Measurements
      ------------------------- */

    const cardWidth = cards[0].getBoundingClientRect().width;
    const viewportWidth = slider.getBoundingClientRect().width;

    const visibleCards = Math.floor(viewportWidth / cardWidth);
    const maxIndex = Math.max(0, cards.length - visibleCards);

    /* -------------------------
        State
      ------------------------- */

    let currentIndex = 0;
    let currentPosition = 0;

    let isDragging = false;
    let startX = 0;
    let startY = 0;
    let startPosition = 0;
    let lastDragDistance = 0;
    let totalDragDistance = 0;
    let justDragged = false;

    const clickThreshold = 8;
    const dragThreshold = 30;

    /* -------------------------
        Helpers
      ------------------------- */

    function updateNav(index) {
      if (leftArrow) leftArrow.disabled = index === 0;
      if (rightArrow) rightArrow.disabled = index === maxIndex;

      // Hide mask when at last slide
      if (slider) {
        if (index === maxIndex) {
          slider.classList.add("is-last-slide");
        } else {
          slider.classList.remove("is-last-slide");
        }
      }
    }

    function slideTo(index) {
      const clamped = Math.max(0, Math.min(index, maxIndex));
      currentIndex = clamped;
      currentPosition = -clamped * cardWidth;

      track.style.transition = "transform 0.4s ease";
      track.style.transform = `translateX(${currentPosition}px)`;

      updateNav(clamped);
    }

    function snapToNearest() {
      let index = Math.round(Math.abs(currentPosition) / cardWidth);
      index = Math.max(0, Math.min(index, maxIndex));
      slideTo(index);
    }

    /* -------------------------
        Arrows
      ------------------------- */

    leftArrow?.addEventListener("click", () => slideTo(currentIndex - 1));
    rightArrow?.addEventListener("click", () => slideTo(currentIndex + 1));

    /* -------------------------
        Drag Start
      ------------------------- */

    function startDrag(e) {
      if (e.type !== "touchstart") e.preventDefault();

      const transform =
        track.style.transform || getComputedStyle(track).transform;
      if (transform && transform !== "none") {
        currentPosition = new DOMMatrix(transform).e;
      }

      startPosition = currentPosition;
      startX = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
      startY = e.type === "touchstart" ? e.touches[0].clientY : e.clientY;

      isDragging = false;
      totalDragDistance = 0;
      lastDragDistance = 0;

      document.addEventListener("mousemove", handleDrag);
      document.addEventListener("touchmove", handleDrag, { passive: false });
      document.addEventListener("mouseup", endDrag);
      document.addEventListener("touchend", endDrag);
    }

    /* -------------------------
        Drag Move
      ------------------------- */

    function handleDrag(e) {
      const x = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
      const y = e.type === "touchmove" ? e.touches[0].clientY : e.clientY;

      const diffX = x - startX;
      const diffY = y - startY;

      const absX = Math.abs(diffX);
      const absY = Math.abs(diffY);

      totalDragDistance = Math.max(absX, absY);

      if (!isDragging) {
        if (absY > absX && absY > 5) {
          endDrag(e);
          return;
        }
        if (absX > clickThreshold) {
          isDragging = true;
          track.style.transition = "none";
          track.classList.add("dragging");
          document.body.classList.add("slider-dragging");
        } else {
          return;
        }
      }

      e.preventDefault();

      let newPosition = startPosition + diffX;
      const minPosition = -maxIndex * cardWidth;

      if (newPosition > 0) {
        newPosition *= 0.3;
      } else if (newPosition < minPosition) {
        const overshoot = minPosition - newPosition;
        newPosition = minPosition - overshoot * 0.3;
      }

      currentPosition = newPosition;
      lastDragDistance = diffX;

      track.style.transform = `translateX(${currentPosition}px)`;
    }

    /* -------------------------
        Drag End
      ------------------------- */

    function endDrag(e) {
      document.removeEventListener("mousemove", handleDrag);
      document.removeEventListener("touchmove", handleDrag);
      document.removeEventListener("mouseup", endDrag);
      document.removeEventListener("touchend", endDrag);

      track.classList.remove("dragging");
      document.body.classList.remove("slider-dragging");

      if (!isDragging) return;

      e.preventDefault();
      e.stopPropagation();

      isDragging = false;

      justDragged = true;
      setTimeout(() => {
        justDragged = false;
      }, 100);

      if (Math.abs(lastDragDistance) > dragThreshold) {
        const movedCards = Math.max(
          1,
          Math.round(Math.abs(lastDragDistance) / cardWidth)
        );

        if (lastDragDistance < 0) {
          slideTo(currentIndex + movedCards);
        } else {
          slideTo(currentIndex - movedCards);
        }
      } else {
        snapToNearest();
      }
    }

    function handleTrackClick(e) {
      if (justDragged) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    }

    track.addEventListener("click", handleTrackClick, true);

    /* -------------------------
        Prevent image drag
      ------------------------- */

    track.querySelectorAll("img").forEach((img) => {
      img.draggable = false;
      img.addEventListener("dragstart", (e) => e.preventDefault());
      img.addEventListener("contextmenu", (e) => e.preventDefault());
    });

    /* -------------------------
        Bind
      ------------------------- */

    track.addEventListener("mousedown", startDrag);
    track.addEventListener("touchstart", startDrag, { passive: false });

    updateNav(currentIndex);
    collection.dataset.sliderInited = "true";
  }

  function initDesktopSliders() {
    document.querySelectorAll(".custom-hero-collection").forEach((col) => {
      initSliderForCollection(col);
    });
  }

  const mobileQuery = window.matchMedia("(max-width: 999px)");

  function resetMobileState() {
    document.querySelectorAll(".custom-collection-track").forEach((track) => {
      track.style.transform = "none";
      track.style.transition = "none";
      track.classList.remove("dragging");
    });

    document.body.classList.remove("slider-dragging");
  }

  const radios = document.querySelectorAll(
    'input[name="mobile-collection-selector"]'
  );
  const collections = document.querySelectorAll(".custom-hero-collection");

  function switchCollection(handle) {
    collections.forEach((col) => {
      col.classList.toggle(
        "mobile-active",
        col.dataset.collectionHandle === handle
      );
    });
  }

  function initMobileCollections() {
    resetMobileState();
    if (radios[0]) {
      switchCollection(radios[0].dataset.collectionHandle);
    }
  }

  function initDesktopCollections() {
    resetMobileState();
    initDesktopSliders();
  }

  radios.forEach((radio) => {
    radio.addEventListener("change", () => {
      if (radio.checked) {
        switchCollection(radio.dataset.collectionHandle);
        const activeCol = document.querySelector(
          `.custom-hero-collection[data-collection-handle="${radio.dataset.collectionHandle}"]`
        );
        if (activeCol) initSliderForCollection(activeCol);
      }
    });
  });

  function handleModeChange() {
    if (mobileQuery.matches) {
      initMobileCollections();
    } else {
      initDesktopCollections();
    }
  }

  handleModeChange();
  mobileQuery.addEventListener("change", handleModeChange);
});
